import { render, staticRenderFns } from "./EditSkillsKnowledgesForm.vue?vue&type=template&id=51a972e3"
import script from "./EditSkillsKnowledgesForm.vue?vue&type=script&lang=js"
export * from "./EditSkillsKnowledgesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports